import { render, staticRenderFns } from "./PageSeven.vue?vue&type=template&id=12c9d482&scoped=true"
import script from "./PageSeven.vue?vue&type=script&lang=js"
export * from "./PageSeven.vue?vue&type=script&lang=js"
import style0 from "./PageSeven.vue?vue&type=style&index=0&id=12c9d482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c9d482",
  null
  
)

export default component.exports